import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const purchases = [{
  name: 'Sarah M.',
  location: 'Austin, TX'
}, {
  name: 'Jennifer K.',
  location: 'Portland, OR'
}, {
  name: 'Michelle R.',
  location: 'Denver, CO'
}, {
  name: 'Amanda L.',
  location: 'Seattle, WA'
}, {
  name: 'Lisa P.',
  location: 'Phoenix, AZ'
}, {
  name: 'Rachel T.',
  location: 'San Diego, CA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 12000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed top-4 right-4 z-50 animate-slide-in" data-id="element-147">
          <div className="bg-white border-2 border-brand-sage shadow-xl rounded-lg p-4 pr-10 max-w-xs" data-id="element-148">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-brand-text-muted hover:text-brand-text-dark" data-id="element-149">
              <XIcon className="w-4 h-4" data-id="element-150" />
            </button>
            <div className="flex items-start gap-3" data-id="element-151">
              <div className="w-10 h-10 rounded-full bg-brand-sage/20 flex items-center justify-center shrink-0" data-id="element-152">
                <span className="text-brand-forest font-bold text-sm" data-id="element-153">✓</span>
              </div>
              <div data-id="element-154">
                <p className="font-semibold text-brand-text-dark text-sm" data-id="element-155">
                  {currentPurchase.name}
                </p>
                <p className="text-xs text-brand-text-muted" data-id="element-156">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-sage font-medium mt-1" data-id="element-157">
                  Just purchased The Thyroid Reset Cookbook™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}